module.exports = {
	init: function () {
		$(function() {
			var sliders = $(".block.slider .items");
			if (sliders.length > 0) {
				for (var i = 0; i < sliders.length; i++) {
					// Init first slider
					const slider = $(sliders[i]);
					const slides = slider.children(".slick-slide");

					slider.slick({
						slidesToShow: 3,
						slidesToScroll: 3,
						dots: true,
						autoplay: false,
						infinite: true,
						arrows: false,
						responsive: [
							{
								breakpoint: 900,
								settings: {
									slidesToShow: 1,
									slidesToScroll: 1,
									draggable: true,
									arrows: true,
									dots: false
								},
							},
						],
					});
				}
			}

			var sliderWithNav = $(".block.slider-with-nav");
			if (sliderWithNav.length > 0) {
				for (var i = 0; i < sliderWithNav.length; i++) {
					var main = $(sliderWithNav[i]).find(".items");
					var nav = $(sliderWithNav[i]).find(".items-nav");

					window.addEventListener("load", function () {
						if (window.innerWidth < 768) {
							// Init first slider
							$(main).slick();
						} else if (window.innerWidth > 768) {
							// Init first slider
							$(main).slick();
							// Init nav slider
							$(nav).slick();
						}
					});
					window.addEventListener("resize", function () {
						if (
							window.innerWidth < 768 &&
							$(nav).hasClass("slick-initialized")
						) {
							$(nav).slick("unslick");
						} else if (
							window.innerWidth > 768 &&
							!$(nav).hasClass("slick-initialized")
						) {
							$(nav).slick();
						}
					});
				}
			}		
		});
	}
};
